import { ObjectHelpers } from "../../helpers/object-helpers";
import { QuoteType } from "../trade/trade.model";

export class ChartSettingsPopupModel {
    public displayOrderConfirmationPopup = true;
    public defaultQuoteQuantity = 1000;
    public defaultQuoteType = QuoteType.Shares;
    public displayPremarket = true;
    public displayPostmarket = true;
    public displayChartSettingZoomAndScroll = true;
    public displayMainChartChangePercentVisibleCandles = false;
    public displayChartSettingBuySellFlags = true;
    public enableRightEdgePadding = true;
    public pnpBrowserChartsByDefault = true;
    
    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}